<template>
  <div>
    <div v-if="postDetails !== null">
      <div class="row">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="row" v-if="postDetails !== null">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <div v-if="postDetails.mediaType == 'image'" style="width: 100%">
                      <img
                        v-if="typeof postDetails.imageUrlCache !=='undefined'"
                        :src="postDetails.imageUrlCache"
                        alt
                      />
                      <img :src="postDetails.imageUrl" v-else alt />
                    </div>
                    <div v-if="postDetails.mediaType == 'video'" style="width: 100%">
                      <video
                        :poster="postDetails.imageUrlCache"
                        v-if="typeof postDetails.imageUrlCache !=='undefined'"
                        controls
                        class="video-contain"
                      >
                        <source
                          v-if="typeof postDetails.videoUrlCache !=='undefined'"
                          :src="postDetails.videoUrlCache"
                          type="video/mp4"
                        />
                        <source v-else :src="postDetails.videoUrl" type="video/mp4" />
                      </video>
                      <video v-else :poster="postDetails.imageUrl" controls class="video-contain">
                        <source
                          v-if="typeof postDetails.videoUrlCache !=='undefined'"
                          :src="postDetails.videoUrlCache"
                          type="video/mp4"
                        />
                        <source v-else :src="postDetails.videoUrl" type="video/mp4" />
                      </video>
                    </div>
                    <div v-if="postDetails.mediaType == 'carousel'" style="width: 100%">
                      <img
                        v-if="typeof postDetails.post.imageUrlCache !=='undefined'"
                        :src="postDetails.imageUrl"
                        alt
                      />
                      <img :src="postDetails.imageUrl" v-else alt />
                    </div>
                  </div>
                </div>
                <div class="row" v-if="postStats !==null" style="position:relative;">
                  <div class="col-md-12" style="text-align:center;">
                    <div class="stats-container" v-if="postStats.viewCount !=null">
                      <h5>{{postStats.viewCount }}</h5>
                      <span>views</span>
                    </div>

                    <div class="stats-container">
                      <h5>{{postStats.likeCount}}</h5>
                      <span>likes</span>
                    </div>

                    <div class="stats-container">
                      <h5>{{postStats.commentCount}}</h5>
                      <span>comments</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5" style="padding-left: 25px;">
                <div class="row" style="margin-top:25px; margin-bottom:25px;">
                  <div class="col-md-12">
                    <badge type="primary">{{postDetails.mediaType}}</badge>
                    <badge type="danger" style="margin-left:5px;">{{postDetails.adFormat}}</badge>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p>
                      Brand:
                      <a
                        target="_blank"
                        :href="'https://instagram.com/'+postDetails.instagramProfile"
                      >@{{postDetails.instagramProfile}}</a>
                    </p>

                    <p style="white-space: pre-wrap;">{{postDetails.caption}}</p>
                    <p>
                      Post:
                      <a
                        target="_blank"
                        :href="'https://instagram.com/p/'+postDetails.shortcode"
                      >https://instagram.com/p/{{postDetails.shortcode}}</a>
                    </p>

                    <p>
                      Landing Page:
                      <a
                        v-if="typeof postDetails.adLink !== null"
                        target="_blank"
                        :href="postDetails.adLink"
                      >{{postDetails.adLink}}</a>
                    </p>
                  </div>
                </div>

                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="lds-dual-ring"></div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import _ from "underscore";
import { VueAutosuggest } from "vue-autosuggest";
import { adDetailApi } from "@/config/appSettings";
import { mapGetters, mapActions } from "vuex";
import store from "@/store/index.js";
import IgProfile from "@/libs/ig/profileData";
import { Badge } from "src/components/UIComponents";
const Math = require("mathjs");
export default {
  data: () => ({
    auth: null,
    loadingOverlay: false,
    loadingPostStats: false,
    loadingOverlayText: null,
    profile: null,
    instagramProfile: null,
    profileSearch: null,
    postDetails: null,
    currentInstagram: null,
    campaigns: [],
    selectCollaboration: null,
    collabFormProps: null,
    campaignDropdown: [],
    currentInstagramId: null,
    collabPostsActive: [],
    openCampaigns: [],
    totalPostEngagement: null,
    postEngagementRate: null,
    hashtagsUsed: [],
    hashtagsRanked: [],
    instagramProfileEr: null,
    postStats: {
      likeCount: null,
      viewCount: null,
      commentCount: null,
    },
  }),
  components: {
    VueAutosuggest,
    [Badge.name]: Badge,
  },
  name: "AdDetail",
  methods: {
    async loadPost() {
      // THIS IS PAGE
      try {
        let postCheckUrl = `${adDetailApi}/?usertoken=${this.auth}&shortcode=${this.$route.params.shortcode}`;
        console.log("POST CHECK URL:", postCheckUrl);
        let instagramPostResponse = await axios.get(postCheckUrl);
        console.log("POST DATA:", instagramPostResponse.data);
        if (instagramPostResponse.data.success == true) {
          this.postDetails = instagramPostResponse.data.result;
          console.log("POST DETAILS:", this.postDetails);
          this.totalPostEngagement = 0;
          if (typeof this.postDetails.likeCount !== "undefined") {
            if (!isNaN(this.postDetails.likeCount)) {
              //console.log("LIKE COUNT:", this.postDetails.post.likeCount);
              this.postStats.likeCount = this.postDetails.likeCount;
            }
          }
          if (typeof this.postDetails.commentCount !== "undefined") {
            if (!isNaN(this.postDetails.commentCount)) {
              //console.log("COMMENT COUNT:", this.postDetails.post.commentCount);
              this.postStats.commentCount = this.postDetails.commentCount;
            }
          }

          if (typeof this.postDetails.viewCount !== "undefined") {
            if (!isNaN(this.postDetails.viewCount)) {
              ///console.log("COMMENT COUNT:", this.postDetails.post.viewCount);
              this.postStats.viewCount = this.postDetails.viewCount;
            }
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      // THIS IS PAGE
      this.loadingOverlay = true;
      this.loadingOverlayText = "Loading...";
      await this.loadPost();
      this.loadingOverlay = false;
    },
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  },
  computed: {
    ...mapGetters(["profileStore"]),
  },
};
</script>

<style scoped>
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}
.stats-container {
  text-align: center;
  /*width: 200px;
  float: left;*/
  padding: 10px;
  margin-right: 20px;
  display: inline-block;
}
.stats-container span {
  font-size: 12px;
  color: gray;
}
.stats-container h5 {
  font-size: 18px;
  margin: 0px;
  padding: 0px;
}
.video_container {
  position: relative;
}
.video_container img.poster {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 10;
}
.video-contain {
  position: relative;
  top: 0;
  left: 0;
  max-width: 100%;
  background: #ccc; /* Random BG colour for unloaded video elements */
}
</style>